import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import IconButton from '@mui/material/IconButton';
import { useCallback } from 'react';
import { thunkGoToGameGuidePage } from '../redux/actions/gameGuideActions';
import { useAppDispatch } from '../redux/store';
const CONTAINER_CSS = css `
  display: inline-block;
  opacity: 0.35;
`;
export const GameGuideHelpButton = ({ pageType, title }) => {
    const dispatch = useAppDispatch();
    const onClickHelp = useCallback((e) => {
        e.stopPropagation();
        dispatch(thunkGoToGameGuidePage(pageType));
    }, [dispatch, pageType]);
    return (_jsx("div", { css: CONTAINER_CSS, children: _jsx(IconButton, { size: 'small', onClick: onClickHelp, color: 'inherit', title: title, children: _jsx(HelpOutlineRoundedIcon, {}) }) }));
};
